export const PROJECT_FIELD_GQL_TYPE = 'JiraProjectField';
